import React from 'react';
import { useCartActionContext } from "../components/cart-context";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { FormButton } from '../components/form-elements';
import { navigate } from "gatsby";
import { useColourPalettes } from "../hooks/use-colour-palettes";
import { GlutenFreeIcon, DairyFreeIcon, VeganIcon } from "../components/dietary-options";

export default function CakeItemDetail({ cake, hideActions }) {
    const { removeCake } = useCartActionContext();
    const image = getImage(cake.imageFile);

    return (
        <div className="flex flex-row pt-4 pb-3">
            <div className="px-1">
                <GatsbyImage image={image} alt="Pasteleria Cake" className="max-h-20 w-20 sm:max-h-36 mr-auto sm:w-36" objectFit="scale-down" />
            </div>
            <div className="flex flex-col p-1">
                <p className="font-ovo uppercase text-base md:text-lg tracking-wider text-gray-800 pb-1" >{cake.name}</p>
                <CakeProperty label={"size"} value={`${cake.selectedSize}`} />
                {!cake.selectedFlavour ? <></> : <CakeProperty label={"flavour"} value={cake.selectedFlavour} />}
                {!cake.selectedTexture ? <></> : <CakeProperty label={"texture"} value={cake.selectedTexture} />}
                {!cake.selectedDecoration ? <></> : <CakeProperty label={"decoration"} value={cake.selectedDecoration} />}
                {!cake.selectedCakeShape ? <></> : <CakeProperty label={"shape"} value={cake.selectedCakeShape} />}
                {!cake.selectedSet1Colour ? <></> : <CakeProperty label={cake.set1ColourLabel} value={cake.selectedSet1Colour} color={cake.selectedSet1Colour} />}
                {!cake.selectedSet2Colour ? <></> : <CakeProperty label={cake.set2ColourLabel} value={cake.selectedSet2Colour} color={cake.selectedSet2Colour} />}
                {!cake.selectedSet3Colour ? <></> : <CakeProperty label={cake.set3ColourLabel} value={cake.selectedSet3Colour} color={cake.selectedSet3Colour} />}
                {!cake.selectedSet4Colour ? <></> : <CakeProperty label={cake.set4ColourLabel} value={cake.selectedSet4Colour} color={cake.selectedSet4Colour} />}
                {!cake.selectedSet5Colour ? <></> : <CakeProperty label={cake.set5ColourLabel} value={cake.selectedSet5Colour} color={cake.selectedSet5Colour} />}
                {!cake.selectedSet6Colour ? <></> : <CakeProperty label={cake.set6ColourLabel} value={cake.selectedSet6Colour} color={cake.selectedSet6Colour} />}
                {!cake.selectedSet7Colour ? <></> : <CakeProperty label={cake.set7ColourLabel} value={cake.selectedSet7Colour} color={cake.selectedSet7Colour} />}
                {!cake.selectedSet8Colour ? <></> : <CakeProperty label={cake.set8ColourLabel} value={cake.selectedSet8Colour} color={cake.selectedSet8Colour} />}
                {!cake.selectedSet9Colour ? <></> : <CakeProperty label={cake.set9ColourLabel} value={cake.selectedSet9Colour} color={cake.selectedSet9Colour} />}
                {!cake.selectedSet10Colour ? <></> : <CakeProperty label={cake.set10ColourLabel} value={cake.selectedSet10Colour} color={cake.selectedSet10Colour} />}
                {!cake.cakeTopperMessage ? <></> : <CakeProperty label={"cake inscription"} value={cake.cakeTopperMessage} />}

                {(!cake.selectedDietaryOptionIsGF
                    && !cake.selectedDietaryOptionIsV
                    && !cake.selectedDietaryOptionIsDF)
                    ? <></>
                    :
                    <CakeDietaryProperty
                        isGlutenFree={cake.selectedDietaryOptionIsGF}
                        isVegan={cake.selectedDietaryOptionIsV}
                        isDairyFree={cake.selectedDietaryOptionIsDF} />}

                {
                    hideActions ? <></> :
                        <div className="flex flex-col sm:flex-row pt-3">
                            <FormButton label={"EDIT"} onClick={() => navigate(`/cakes/${cake.metadata.subType}/${cake.code}?id=${cake.key}`)} size={"sm"} isSecondary={true} />
                            <FormButton label={"REMOVE"} onClick={() => removeCake(cake)} size={"sm"} isSecondary={true} />
                        </div>
                }
            </div>
        </div>
    )
}

const CakeDietaryProperty = ({ isGlutenFree, isVegan, isDairyFree }) => {
    return (
        <div className="flex flex-wrap items-center font-light text-sm sm:text-base">
            <span className="font-gotu lowercase text-[0.65rem] md:text-xs tracking-wider text-gray-500 mt-0.5 mr-1">dietary:</span>
            <div className="flex flex-wrap gap-[.05rem] items-top sm:items-center mt-0.5">
                {
                    !isGlutenFree ? <></> : <GlutenFreeIcon className="max-h-5 mr-1" />
                }
                {
                    !isVegan ? <></> : <VeganIcon className="max-h-5 mr-1" />
                }
                {
                    !isDairyFree ? <></> : <DairyFreeIcon className="max-h-5 mr-1" />
                }
            </div>
        </div>
    )
}

const CakeProperty = ({ label, value, color }) => {
    const result = useColourPalettes().find(c => c.colour === color);
    const style = (result) ? { "backgroundColor": result.hex } : {};
    const colorElement = !!color ? <span className="h-3 w-3 ml-1.5 mt-[.25rem] md:mt-0 ring-1 ring-slate-500 rounded-lg" style={style} /> : <></>

    return (
        <div className="flex flex-wrap items-center text-xs">
            <span className="font-gotu lowercase text-[0.65rem] md:text-xs tracking-wider text-gray-500 mr-1">{label}:</span>
            <div className="flex flex-wrap items-top sm:items-center">
                <span className="font-ovo text-xs md:text-sm tracking-wider leading-5 md:leading-6 text-gray-800">{value}</span>
                {colorElement}
            </div>
        </div>
    )
}